var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-278.000000, -248.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8181818,11.8181818 C11.8181818,12.470882 11.2890638,13 10.6363636,13 L2.36363636,13 C1.7109362,13 1.18181818,12.470882 1.18181818,11.8181818 L1.18181818,1.18181818 C1.18181818,0.529118022 1.7109362,0 2.36363636,0 L8.27272728,0 L11.8181818,3.54545454 L11.8181818,11.8181818 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27272728,0 L11.8181818,3.54545454 L9.1590909,3.54545454 C8.66956579,3.54545454 8.27272728,3.14861602 8.27272728,2.6590909 L8.27272728,0 L8.27272728,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39772728,3.8409091 L7.23863636,3.8409091 C7.53409091,3.8409091 7.68181818,3.98863637 7.68181818,4.2840909 L7.68181818,4.2840909 C7.68181818,4.57954545 7.53409091,4.72727272 7.23863636,4.72727272 L3.39772728,4.72727272 C3.10227273,4.72727272 2.95454546,4.57954545 2.95454546,4.2840909 L2.95454546,4.2840909 C2.95454546,3.98863636 3.10227273,3.8409091 3.39772728,3.8409091 Z",
    fillOpacity: 0.881,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39772728,6.5 L9.01136364,6.5 C9.30681818,6.5 9.45454546,6.64772727 9.45454546,6.94318182 L9.45454546,6.94318182 C9.45454546,7.23863637 9.30681818,7.38636364 9.01136364,7.38636364 L3.39772728,7.38636364 C3.10227273,7.38636364 2.95454546,7.23863637 2.95454546,6.94318182 L2.95454546,6.94318182 C2.95454546,6.64772727 3.10227273,6.5 3.39772728,6.5 Z",
    fillOpacity: 0.881,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39772728,9.1590909 L9.01136364,9.1590909 C9.30681818,9.1590909 9.45454546,9.30681818 9.45454546,9.60227272 L9.45454546,9.60227272 C9.45454546,9.89772727 9.30681818,10.0454545 9.01136364,10.0454545 L3.39772728,10.0454545 C3.10227273,10.0454545 2.95454546,9.89772727 2.95454546,9.60227272 L2.95454546,9.60227272 C2.95454546,9.30681818 3.10227273,9.1590909 3.39772728,9.1590909 Z",
    fillOpacity: 0.881,
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile3);
export default __webpack_public_path__ + "static/media/file3.7c90df0c9e8ff44aa7d84496335c469e.svg";
export { ForwardRef as ReactComponent };